import Formsy from 'formsy-react';
import React, { useRef, useState } from 'react';
import { Form, Grid, Dimmer, Loader, Button } from 'semantic-ui-react';
import DGTextbox from '../../components/FormControls/Textbox/DGTextbox';
import { withRouter } from 'react-router';
import { inviteSellerDriver } from '../../services/Driver';
import './InviteSellerDriverContainer.less';
import { isValidEmail, isNotBlankString } from '../../helpers/validation';
import { NavigationUrls } from '../../constants/NavigationUrls'
import { format , normalize} from 'react-phone-input-auto-format'
import { isValidCellNumber } from '../../helpers/validation';
import { connect, useSelector, useDispatch } from 'react-redux';
import { SUCCESS, ERROR } from '../../constants/NotificationType';
import { showNotificationMessage } from '../../store/actions/reactNotification'

function InviteSellerDriverContainer({ history }) {
    const formRef = useRef(null);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [showLoader, setLoader] = useState(false);
    const [nameError, setNameError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [submitError, setSubmitError] = useState('');
    const [errorOnPhoneField, setErrorOnPhoneField] = useState(false);
    const [phoneFieldErrorMeg, setPhoneFieldErrorMeg] = useState("");

    const reactNotification = useSelector(({ reactNotification }) => reactNotification);

    const dispatch = useDispatch();
    const notification = useSelector(
        state => state.reactNotification
    );


    const displayLoader = () => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        });
        document.body.style.overflowY = 'hidden';
        setLoader(true);
    }

    const hideLoader = () => {
        document.body.style.overflowY = 'unset';
        setLoader(false);
    }

    const resetForm = () => {
        setName('');
        setEmail('');
        setNameError(false);
        setEmailError(false);
        setEmailErrorMessage('');
        setSubmitError('');
        setPhone("");
        setErrorOnPhoneField(false);
        setPhoneFieldErrorMeg("");
    }

    const validateForm = () => {
        let invalid = false;
        setSubmitError('');

        if (!isNotBlankString([], name)) {
            setNameError(true);
            invalid = true;
        } else {
            setNameError(false);
        }

        if (!isValidEmail([], email)) {
            setEmailError(true);
            setEmailErrorMessage(email.trim().length ? 'Invalid Email' : 'Email is required');
            invalid = true;
        } else {
            setEmailError(false);
            setEmailErrorMessage('');
        }

        if(!validatePhoneField(phone)){
            invalid = true;
        }

        return !invalid;
    }

    const onSubmit = () => {
        if (!validateForm()) {
            return;
        }

        // Split full name into firstName and lastName
        const nameParts = (name || "").trim().split(/\s+/);
        const firstName = nameParts.shift() || "";
        const lastName = nameParts.join(" ");


        displayLoader();

        inviteSellerDriver({
            firstName,
            lastName,
            email: email.trim().toLowerCase(),
            cellPhone: normalize(phone)
        }).then(res => {
            if (res.resStatus >= 400) {
                setSubmitError(res.message || 'Unable to send invite.');
            } else { 
                    if(res && res?.data?.sellerDriverAlreadyExist == true && res?.data?.sellerDriverCreated == false){
                        setSubmitError('Driver with same email already exist.');
                    }else{
                        resetForm();
                        history.push(NavigationUrls.SELLER_DRIVER);
                    }
            }
        }).catch((e) => {
            console.log(e)
            setSubmitError('Unable to send invite. Please try again.');
        }).finally(() => {
            hideLoader();
        });
    }

    const onInvalidSubmit = () => {
        validateForm();
    }

    const onPhoneKeyDown = (evt) => {
        if (evt.key != 'Backspace' && evt.key != 'Delete' && evt.key != 'Tab') {
            var patt = new RegExp(/^[0-9\b]+$/);
            var res = patt.test(evt.key);
            if (!res)
                evt.preventDefault()
        }
    }

    const onPhoneChange = (e, data) => {
        let value = format(data.value);
        setPhone(value)
        validatePhoneField(value);
    }

    const validatePhoneField = (value = phone) => {
            let isValid = 0;
            if(value.length == 0)
            {
                setErrorOnPhoneField(true)
                setPhoneFieldErrorMeg("Phone Number is required")
                isValid = 0;
            } else
            {
                setErrorOnPhoneField(false);
                setPhoneFieldErrorMeg("");
                isValid = 1;
            }  
            
            if(isValid)
            {
                if(!isValidCellNumber("" ,value))
                {
                    setErrorOnPhoneField(true)
                    setPhoneFieldErrorMeg("Invalid Phone Number")
                    isValid = 0;
                }else
                {
                    setErrorOnPhoneField(false)
                    setPhoneFieldErrorMeg("")
                    isValid = 1;
                }
            }
    
            return isValid;
        }

    return (
        <div className='page invite-driver-container'>
            <div className='main-div'>
                <div className='page-title'>
                    <h1>Invite Driver</h1>
                </div>

                <Formsy onValidSubmit={onSubmit} onInvalidSubmit={onInvalidSubmit} ref={formRef}>
                    <Grid className='form-grid'>
                        <Grid.Row columns={1}>
                            <Grid.Column computer={16} mobile={16}>
                                <DGTextbox
                                    name='name'
                                    label='Name'
                                    placeholder='Name'
                                    type='text'
                                    maxLength={100}
                                    onChange={(e) => setName(e.target.value)}
                                    value={name || undefined}
                                />
                                {nameError && <div className='error-label'>Name is required</div>}
                            </Grid.Column>
                              <Grid.Column computer={16} mobile={16}>
                                <DGTextbox
                                    name='email'
                                    label='Email'
                                    placeholder='john@example.com'
                                    type='email'
                                    maxLength={100}
                                    onChange={(e) => setEmail(e.target.value)}
                                    value={email || undefined}
                                />
                                {emailError && <div className='error-label'>{emailErrorMessage}</div>}
                            </Grid.Column>
                             <Grid.Column computer={16} mobile={16}>
                                <DGTextbox
                                    name='phone'
                                    label='Phone'
                                    placeholder='(000) 000-0000'
                                    type='text'
                                    maxLength={14}
                                    onKeyDown={onPhoneKeyDown}
                                    onChange={(e) => onPhoneChange(e, e.target)}
                                    value={phone || undefined}
                                />
                                {errorOnPhoneField && <div className='error-label'>{phoneFieldErrorMeg}</div>}
                            </Grid.Column>
                        </Grid.Row>

                        {submitError && (
                            <Grid.Row columns={1}>
                                <Grid.Column>
                                    <div className='submit-error'>{submitError}</div>
                                </Grid.Column>
                            </Grid.Row>
                        )}

                        <Grid.Row columns={1} className='btn-row'>
                            <Grid.Column className='btn-container'>
                                <Button
                                    primary
                                    disabled={!name.trim() || !email.trim() || !phone.trim()}
                                    type='submit'
                                    className='continue-btn'
                                >
                                    Send Invite
                                </Button>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Formsy>
            </div>

            {showLoader ? (
                <Dimmer active>
                    <Loader indeterminate size='massive' />
                </Dimmer>
            ) : ''}
        </div>
    );
}

export default withRouter(InviteSellerDriverContainer);
